var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mx-0 px-3",attrs:{"fluid":""}},[_c('div',[_c('h2',[_vm._v("Dashboard View")])])])}
var staticRenderFns = []

export { render, staticRenderFns }